export const formatActionTypeLabel = (actionType: string | null | undefined): string =>
  actionType?.replace(/_/g, ' ') ?? '';
